import React from 'react'
import Paper from 'material-ui/Paper'
import { styles } from './Styles'
import { Link } from 'react-router-dom'
import { themeColors } from '../../styles/theme'
import { Card, CardHeader, CardText } from 'material-ui/Card'
import LiveHelp from 'material-ui/svg-icons/communication/live-help'

const Faq = () => (
  <Paper style={styles.paper}>
    <h4 style={styles.titles}>
      <LiveHelp style={styles.titleIcon} />Domande frequenti
    </h4>
    <Card>
      <CardHeader
        title="Che cos'è swapick.com?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Swapick.com è una piattaforma web, per vendere, acquistare e permutare (barattare) i propri oggetti usati e/o da collezione.
      </CardText>
    </Card>

    <Card>
      <CardHeader
        title="Come faccio a registrarmi?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Clicca su “login”, poi su “registrati” e inserisci i dati richiesti. Dopo aver cliccato sul bottone “registrati” riceverai un'email al tuo indirizzo per la conferma dell'iscrizione.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Quanto costa registrarsi a swapick.com?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        La registrazione a swapick.com è GRATUITA.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Sono già registrato ma non riesco ad accedere, come mai?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per poter accedere al sito è necessario verificare la propria email cliccando il link presente nell’email di conferma iscrizione.
      </CardText>
    </Card>

    <Card>
      <CardHeader
        title="Non ho ricevuto nessuna email di conferma iscrizione, come mai?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Controlla di aver inserito correttamente il tuo indirizzo email oppure che l’email di conferma iscrizione non sia stata riconosciuta come spam dal tuo server di posta e spostata nella casella antispam.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho dimenticato la mia password, cosa posso fare?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Nella pagina di login clicca su "recupera password". Inserisci la tua email e clicca "Resetta la mia password". Ti verrà inviata un'email. Clicca sul link che ricevi via email e poi inserisci una nuova password.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Quanto costa vendere e scambiare i miei oggetti su swapick.com?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Puoi effettuare illimitate vendite e scambi gratuitamente, senza nessuna commissione.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Non posso fare scambi, perché?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Se non hai ancora aggiunto i tuoi oggetti nella tua lista possiedo ti consigliamo di farlo e di caricare il maggior numero di oggetti che ti è possibile. Fai lo stesso per le tue liste voglio e interessi. Questo ti consentirà di poter effettuare scambi.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Che cos’è la lista possiedo?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        La lista possiedo è l’elenco di tutti gli oggetti che possiedi e che hai caricato sul sito. Gli oggetti che hai aggiunto nella tua lista possiedo sono la tua “moneta” per poter ottenere altri oggetti.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Che cos’è la lista voglio?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        La lista voglio è l’elenco degli oggetti che vorresti ottenere. Gli utenti che possiedono quegli oggetti potranno farti proposte di scambio.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Che cos’è la lista interessi?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        La lista interessi è l’elenco degli oggetti che non sono stati ancora aggiunti sul sito da nessun utente. Gli utenti che aggiungeranno quegli oggetti potranno farti proposte di scambio.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Come faccio ad aggiungere oggetti nella mia lista possiedo?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per caricare oggetti nella tua lista possiedo clicca sul bottone “+” (aggiungi oggetto) e compila i campi richiesti. Per i Media (Libri, Musica, Film, Videogiochi e Dischi in Vinile) inserisci il codice isbn, ean, codice catalogo o il titolo dell'oggetto, individua l’edizione in tuo possesso, clicca sul bottone “lo possiedo” e compila i campi richiesti.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Come faccio ad aggiungere oggetti nella mia lista voglio?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per caricare oggetti nella tua lista voglio clicca il bottone “lo voglio” sugli oggetti.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Come faccio ad aggiungere oggetti nella mia lista interessi?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per caricare oggetti nella tua lista interessi clicca sul tab interessi nella tua lista voglio e poi sul bottone “aggiungi interesse”. Compila i campi richiesti e assicurati di inserire più informazioni possibili per fare in modo di ricevere proposte pertinenti.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Quali oggetti posso aggiungere nelle mie liste?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Puoi aggiungere oggetti di ogni genere (ad esclusione degli oggetti proibiti elencati nei “termini e condizioni d’uso”), limitatamente ai mondi e alle categorie del Sito, senza però violare alcuna norma, come espressamente indicato nei “termini e condizioni d'uso” del Sito. Il mancato rispetto delle regole sarebbe una violazione non solo perseguibile a norma di legge, ma anche delle regole di swapick.com con conseguente sospensione dell’account.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho inserito il codice a barre ma il mio libro (o il mio cd, dvd o videogame) non viene trovato, come mai?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Controlla innanzitutto di aver inserito correttamente il codice a barre (isbn, ean, etc.) e di aver selezionato la categoria relativa all’oggetto che stai aggiungendo. Nel caso tu abbia seguito correttamente le istruzioni e non dovessi vedere ancora nessun oggetto ti consigliamo di fare una ricerca scrivendo il nome dell’oggetto (es. titolo del libro). Qualora l’oggetto in tuo possesso non fosse ancora presente nel nostro database, lo puoi inserire tu cliccando sul bottone “inseriscilo tu” (che appare al termine della ricerca automatica) e compilando i campi richiesti.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho inserito i miei oggetti nella mia lista possiedo ma non riesco a fare scambi, come mai?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per poter effettuare scambi devi possedere oggetti che interessino ad altri utenti. Per questo ti consigliamo di caricare il maggior numero di tuoi oggetti nella tua lista possiedo. Se a destra dei tuoi oggetti vedi il bottone verde SCAMBIA vuol dire che uno o più utenti sono interessati agli oggetti in tuo possesso e puoi fare dunque delle proposte di scambio.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho inserito gli oggetti che desidero nella mia lista voglio ma non riesco a fare scambi, come mai?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per poter effettuare scambi partendo dalla tua lista voglio devi possedere oggetti che interessino agli utenti che possiedono gli oggetti che tu desideri. Per questo ti consigliamo di caricare il maggior numero di tuoi oggetti nella tua lista possiedo e di caricare anche il maggior numero di oggetti che desideri nella tua lista voglio. Se a destra dei tuoi oggetti vedi il bottone verde SCAMBIA vuol dire che il tuo interesse si incrocia perfettamente con quello di un altro utente (o di altri utenti), quindi puoi fargli una proposta di scambio.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Come faccio a proporre uno scambio?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per effettuare una proposta di scambio clicca su “Scambia” (visibile nella parte alta del Sito), individua un oggetto che ti piace e clicca su “scegli”. A questo punto inizierai a costruire la proposta di scambio dove ti verrà chiesto ti cedere un tuo oggetto in cambio. Puoi fermarti ad uno scambio singolo (un oggetto per un oggetto) oppure arrivare a costruire uno scambio multiplo (più oggetti per più oggetti) con, eventualmente, anche un conguaglio in denaro. Puoi iniziare a costruire una proposta di scambio anche cliccando il bottone “scambia” (dove presente) a fianco dei tuoi oggetti posseduti e/o voluti.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Posso proporre uno stesso oggetto della mia lista possiedo a più persone contemporaneamente?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        No, puoi impegnare un tuo oggetto in un sola proposta di scambio alla volta. Se l’altra parte rifiuterà la proposta o se la lascerà scadere allora il tuo oggetto tornerà libero e lo potrai proporre per un altro scambio.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Posso proporre più scambi contemporanemente partendo da un oggetto della mia lista voglio?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Sì, partendo dagli oggetti della tua lista voglio puoi proporre tutti gli scambi possibili. Ovviamente effettuerai lo scambio col primo utente che accetterà la tua proposta, quindi è consigliabile fare una proposta alla volta cominciando dallo scambio che reputi migliore.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Posso scambiare oggetti di categorie diverse?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Puoi fare tutte le proposte di scambio possibili anche tra diverse categorie.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho effettuato una proposta di scambio, cosa devo fare?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Niente. All’altro utente sarà comunicata la tua proposta e deciderà se accettarla, rifiutarla o farti una controproposta. In ogni caso sarai avvisato via email.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho ricevuto una proposta di scambio, cosa devo fare?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Quando ricevi una proposta di scambio hai tempo 7 giorni per valutarla (se la lasci scadere non è più valida). Puoi rifiutarla, accettarla o fare una controproposta. Se la accetti riceverai un’email riepilogativa e l'indirizzo di spedizione.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="E’ stata accettata una mia proposta di scambio, cosa devo fare?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Se il tuo livello di affidabilità è inferiore a quello dell'altro Utente, devi spedire tu per primo. Viceversa (cioè se il tuo livello di affidabilità è superiore a quello dell'altro Utente), attendi di ricevere l'oggetto dall'altro Utente prima di spedire il tuo. L'Utente con il livello inferiore di affidabilità (o, a pari livello, con un numero inferiore di scambi) è tenuto sempre a spedire per primo. Questa è una regola inderogabile del Sito per garantire maggiore sicurezza negli scambi. Per approfondimenti leggi le informazioni nella pagina “Guida alla sicurezza”.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho accettato una proposta di scambio, devo spedire?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Se il tuo livello di affidabilità è inferiore a quello dell'altro Utente, devi spedire tu per primo. Viceversa (cioè se il tuo livello di affidabilità è superiore a quello dell'altro Utente), attendi di ricevere l'oggetto dall'altro Utente prima di spedire il tuo. L'Utente con il livello inferiore di affidabilità (o, a pari livello, con un numero inferiore di scambi) è tenuto sempre a spedire per primo. Questa è una regola inderogabile del Sito per garantire maggiore sicurezza negli scambi. Per approfondimenti leggi le informazioni nella pagina “Guida alla sicurezza”.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="A quale indirizzo spedisco?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        All’indirizzo che ti verrà indicato nell’email di accettazione dello scambio, visibile anche nei tuoi “scambi accettati”.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Quanto costa spedire?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Guarda le tariffe sule sito delle Poste (www.poste.it) e leggi la nostra guida per la spedizione dei libri a tariffe ridotte (vedi “come spedire gli oggetti”).
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="E’ stata accettata una mia proposta di scambio ma l’altro utente non vuole spedire, perché?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Se il tuo livello di affidabilità è inferiore a quello dell'altro Utente, devi spedire tu per primo. Viceversa (cioè se il tuo livello di affidabilità è superiore a quello dell'altro Utente), invita l'altro Utente a spedire per primo. L'Utente con il livello inferiore di affidabilità (o, a pari livello, con un numero inferiore di scambi) è tenuto sempre a spedire per primo. Questa è una regola inderogabile del Sito per garantire maggiore sicurezza negli scambi. Per approfondimenti leggi le informazioni nella sezione “Guida alla sicurezza”.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Ho accettato una proposta di scambio ma l'altro utente non vuole spedire, perché?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Se il tuo livello di affidabilità è inferiore a quello dell'altro Utente, devi spedire tu per primo. Viceversa (cioè se il tuo livello di affidabilità è superiore a quello dell'altro Utente), invita l'altro Utente a spedire per primo. L'Utente con il livello inferiore di affidabilità (o, a pari livello, con un numero inferiore di scambi) è tenuto sempre a spedire per primo. Questa è una regola inderogabile del Sito per garantire maggiore sicurezza negli scambi. Per approfondimenti leggi le informazioni nella sezione “Guida alla sicurezza”.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Perché l'utente con il livelo di affidabilità più basso deve sempre spedire per primo?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        E' una regola inderogabile del Sito per garantire maggiore sicurezza negli scambi. Per approfondimenti leggi le informazioni nella sezione “Guida alla sicurezza”.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Che cos’è il valore del bene?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        E’ il valore in Euro che dai al tuo oggetto, per la vendita (comprese eventuali spese di spedizione) o per avere un riferimento di valore per lo scambio. In entrambi i casi, consigliamo di dare valori adeguati agli oggetti.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Cosa sono le condizioni?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Per “condizioni” si intende lo stato di conservazione del tuo oggetto. Possono essere scarse, buone, ottime e nuove. E’ molto importante inserire condizioni reali e oggettive.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Cosa sono i feedback?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Sono i giudizi degli utenti (vedi pagina "Guida alla Sicurezza")
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Cos'è la percentuale indicata nel profilo di un utente?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        E' l'indice di affidabilità dell'Utente. Trovi tutte le informazioni alla pagina “Guida alla Sicurezza”.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Che cos’è la pagina che vedo cliccando su “Scambia”?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        E’ l’elenco degli oggetti tra i quali scegliere quelli che potresti avere in cambio dei tuoi.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Perché solo alcuni oggetti nella mia lista possiedo hanno il bottone “Scambia”?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Gli oggetti che hanno il bottone “scambia” nella tua lista possiedo sono desiderati da uno o più utenti e sono stati quindi aggiunti in una o più liste voglio. Se a fianco del tuo oggetto non c'è il bottone “scambia” devi attendere che un utente lo inserisca nella sua lista voglio. Quando questo succederà verrai avvisato via email.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Che cos’è la pagina “i miei scambi”?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        E’ il riepilogo delle tue transazioni (in corso e concluse), delle proposte che hai fatto e di quelle che hai ricevuto.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Cosa vuol dire che un oggetto è “occupato” (simbolo del lucchetto)?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Vuol dire che l’oggetto che possiedi è già impegnato in un'altra transazione. Per renderlo nuovamente disponibile devi annullare la proposta precedente (o rifiutarla se l'hai ricevuta) oppure attendere che scada.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Non riesco a proporre lo scambio e vedo la pagina dei miei dati personali, come mai?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Vuol dire che è la tua prima proposta di scambio e che non hai ancora inserito il tuo indirizzo di spedizione. Devi completare i tuoi dati per poter effettuare la proposta.
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Cosa sono gli eCoin?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Gli eCoin sono crediti, ma non possono essere usati per gli scambi. Con gli eCoin è possibile acquistare i servizi del sito (vedi “servizi aggiuntivi”).
      </CardText>
    </Card>
    <Card>
      <CardHeader
        title="Cosa sono i servizi aggiuntivi?"
        actAsExpander={true}
        showExpandableButton={true}
        titleStyle={styles.question}
      />
      <CardText expandable={true} style={styles.answer}>
        Sono tutti i servizi a pagamento usufruibili all'interno del sito per mezzo dei propri crediti eCoin (vedi “servizi aggiuntivi”).
      </CardText>
    </Card>
  </Paper>
)

export default Faq



// WEBPACK FOOTER //
// ./src/common/Infotext/Faq.js